import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = {
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic_modal = _resolveComponent("basic-modal")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_basic_modal, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.t$('help.title')), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                  type: "button",
                  class: "close",
                  "aria-label": "Close"
                }, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.t$('help.description', {version: _ctx.version})), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                  type: "button",
                  class: "btn btn--second"
                }, _toDisplayString(_ctx.t$('help.btnClose')), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadManual && _ctx.downloadManual(...args))),
                  type: "button",
                  class: "btn btn--primary"
                }, _toDisplayString(_ctx.t$('help.btnManual')), 1 /* TEXT */)
              ])
            ], undefined, true),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_ErrorModal, {
      messageError: _ctx.errMsg,
      onHandlingOk: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errMsg = ''))
    }, null, 8 /* PROPS */, ["messageError"])
  ], 64 /* STABLE_FRAGMENT */))
}